import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
}), 'KeyboardBackspace');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/KeyboardBackspace.js
// module id = 4331
// module chunks = 2